"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const http_1 = require("./http");
const api_1 = tslib_1.__importDefault(require("./api"));
function api(url, data, showError = true) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let u = api_1.default.apis[url];
        if (!u) {
            throw new Error(`API ${url} not found`);
        }
        let res;
        try {
            if (!(typeof u == 'string')) {
                if (u.method.toLowerCase() == 'get') {
                    res = yield http_1.http.request({
                        url: `${u.base_url == null ? api_1.default.base_url : u.base_url}${u.url}`,
                        method: u.method,
                        needAuth: u.auth,
                        params: data,
                    });
                }
                else {
                    res = yield http_1.http.request({
                        url: `${u.base_url == null ? api_1.default.base_url : u.base_url}${u.url}`,
                        method: u.method,
                        needAuth: u.auth,
                        responseType: u.responseType || 'json',
                        data,
                    });
                }
            }
            else {
                res = yield http_1.http.request({
                    url: `${api_1.default.base_url}${u}`,
                    method: 'GET',
                    params: data,
                });
            }
        }
        catch (err) {
            if (showError) {
                console.log(`[Server]`, err);
            }
            return { code: err.code, message: err.message };
        }
        if (res.code && !(res.code === 1000 || res.code === 200) && showError) {
            console.log(`[Server]`, res);
        }
        return res;
    });
}
exports.default = api;
